// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserBalanceQueryVariables = Types.Exact<{
  walletCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UserBalanceQuery = { __typename?: 'Query', banking?: { __typename?: 'Banking', id: string, myBalances?: { __typename?: 'BankingBalanceConnection', edges?: Array<{ __typename?: 'BankingBalanceEdge', cursor: string, node?: { __typename: 'BankingBalance', id: string, currency?: string, totalBalance?: number, totalBonusBalance?: number, bonusBalance?: number, realBalance?: number, lockedRealBalance?: number, cashierBalance?: number } }> } } };

export type BalanceFragment = { __typename: 'BankingBalance', id: string, currency?: string, totalBalance?: number, totalBonusBalance?: number, bonusBalance?: number, realBalance?: number, lockedRealBalance?: number, cashierBalance?: number };

export const BalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment BalanceFragment on BankingBalance {
  id
  currency
  totalBalance
  totalBonusBalance
  bonusBalance
  realBalance
  lockedRealBalance
  cashierBalance
  __typename
}
    `;
export const UserBalanceQueryDocument = /*#__PURE__*/ gql`
    query UserBalanceQuery($walletCurrency: String, $first: Int) {
  banking {
    id
    myBalances(walletCurrency: $walletCurrency, first: $first) {
      edges {
        node {
          ...BalanceFragment
        }
        cursor
      }
    }
  }
}
    ${BalanceFragmentDoc}`;
export function useUserBalanceQuery(baseOptions?: Apollo.QueryHookOptions<UserBalanceQuery, UserBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBalanceQuery, UserBalanceQueryVariables>(UserBalanceQueryDocument, options);
      }
export function useUserBalanceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBalanceQuery, UserBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBalanceQuery, UserBalanceQueryVariables>(UserBalanceQueryDocument, options);
        }
export function useUserBalanceQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserBalanceQuery, UserBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserBalanceQuery, UserBalanceQueryVariables>(UserBalanceQueryDocument, options);
        }
export type UserBalanceQueryHookResult = ReturnType<typeof useUserBalanceQuery>;
export type UserBalanceQueryLazyQueryHookResult = ReturnType<typeof useUserBalanceQueryLazyQuery>;
export type UserBalanceQuerySuspenseQueryHookResult = ReturnType<typeof useUserBalanceQuerySuspenseQuery>;
export type UserBalanceQueryQueryResult = Apollo.QueryResult<UserBalanceQuery, UserBalanceQueryVariables>;